import { AgmInfoWindow } from '@agm/core';
import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from 'common/components/base.component';
import { AddressInputComponent } from 'common/components/address.input/address.input.component';
import { HubFeed } from 'models/hub/hub.feed';
import { HubVisitorFeatureToggle, HubVisitorToggleDataSource } from 'models/hub/hub.visitor.feature.toggle';
import { HubApiService } from 'services/hub.api.service';
import { AlertifyService } from 'services/alertify.service';
import { HubComponent } from 'components/hub/hub.component';
import { ModalService } from 'common/services/modal.service';
import {
  ToggleAndDataSourceStore,
  HubFacebookPageFeedsStore,
  HubFacebookLocationFeedsStore,
} from 'stores/hub.calendar.store';
import {
  HubFacebookFeedsCommand,
  AddFacebookGeneralFeedCommand,
} from 'commands/hub/event/add.facebook.general.feed.command';
import { PullGooglePlaceTypeModalActions } from 'components/hub/pull.google.place.type.modal/pull.google.place.type.modal.provider';
import { localStorageKeys } from 'common/constants/local.storage.keys';
import { PullGooglePlaceTypeModalComponent } from 'components/hub/pull.google.place.type.modal/pull.google.place.type.modal.component';
import { ButtonTriggerEvent } from 'common/components/button/button.component';
import { ConfirmModalData, ConfirmModalActions } from 'common/components/confirm.modal/confirm.modal.provider';
import { ConfirmModalComponent } from 'common/components/confirm.modal/confirm.modal.component';
import { constantTooltip } from 'common/constants/constant.tooltip';
import { ConfigService } from 'services/config.service';
import { AddFacebookLocationFeedCommand } from 'commands/hub/event/add.facebook.location.feed.command';
import { GeoService } from 'services/geo.service';
import { EventPageAdding } from '../../event.add.page';
import { EventLocationAdding } from '../../event.add.location';
import { config } from '../../../../../../config/config';
import { PlaceService } from '../../../../../services/place.service';
import { UpdateGeoLocationStore } from '../../../../../stores/hub.calendar.store';

@Component({
  selector: 'ig-search-geofence',
  templateUrl: './search.geofence.component.html',
  styleUrls: ['./search.geofence.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SearchGeofenceComponent extends BaseComponent implements OnInit {
  @Input() public type = 'place';
  public eventPage = new EventPageAdding();
  public placePageFacebook = new EventPageAdding();
  public eventLocation = new EventLocationAdding();
  public locationPlaceId = null;
  public locationPlaceCityState = null;
  public eventFormGroup: FormGroup;
  public placeFacebookFormGroup: FormGroup;
  public locationFormGroup: FormGroup;
  public hubName: string;
  public pageSource: string;
  public locationSource = 'facebook';
  public zoom = ConfigService.config.google.fullUSMapZoom;
  public isShowMarker = false;
  public isFeedExisted = false;
  public isConfirmChecked = false;
  public isLoadingFeeds = false;
  public inAddingLocationFeed = false;
  public isLoadingPlaceSource = false;
  public showSuccessInfo = false;
  public percentage = '';
  public autoCompletedAddress: any;
  public mileToMeters = config.mileToMeters;
  @ViewChild('infoWindow') infoWindow: AgmInfoWindow;
  @ViewChild('confirmCheckbox') confirmCheckbox: ElementRef;
  @ViewChild('addressInput') addressInput: AddressInputComponent;
  public hubPages: HubFeed[];
  public hubLocations: HubFeed[];
  public pageTooltip: string;
  public isRepullExistingCategories = false;
  public toggles = new HubVisitorFeatureToggle();
  public selectedGoogleCategories: any = [];
  public sourceItems: any;
  public urlSourceItems = [
    {
      text: 'Eventbrite',
      value: 'eventbrite',
    },
    {
      text: 'Eventful',
      value: 'eventful',
    },
  ];

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private hubApiService: HubApiService,
    private activatedRoute: ActivatedRoute,
    private alertify: AlertifyService,
    private modalService: ModalService,
    private parent: HubComponent,
    private renderer: Renderer2,
    private toggleAndDataSourceStore: ToggleAndDataSourceStore,
    private hubFacebookFeedsStore: HubFacebookPageFeedsStore,
    private updateGeoLocationStore: UpdateGeoLocationStore,
    private hubFacebookLocationFeedsStore: HubFacebookLocationFeedsStore
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;

    this.eventPage.tags = 'Visitor Posts';
    this.parent.location = 'Content Management';
    this.pageSource = 'eventbrite';
    this.changeTooltip();
    this.eventFormGroup = this.formBuilder.group({
      facebookPageUrlOrName: [null, [Validators.required]],
      displayTitle: [null, null],
      tags: [null, null],
    });
    this.placeFacebookFormGroup = this.formBuilder.group({
      facebookPageUrlOrName: [null, [Validators.required]],
      displayTitle: [null, null],
      tags: [null, null],
    });
    this.locationFormGroup = this.formBuilder.group({
      address: [null, [Validators.required]],
      displayTitle: [null, null],
      filterByCity: [null, null],
      tags: [null, null],
      radius: [null, [Validators.required]],
    });

    this.toggleAndDataSourceStore.toggleAndDataSourceCommand
      .takeUntil(this.isDestroyed)
      .subscribe((toggleCommand: HubVisitorToggleDataSource) => {
        if (toggleCommand.toggle) {
          this.toggles = toggleCommand.toggle;
          this.eventLocation.isFilterByCity = this.toggles.multipleCities;
          if (toggleCommand && toggleCommand.dataSource) {
            if (this.type === 'event') {
              this.sourceItems = [
                // Eventbrite had turned the event api off
                //     {
                //     text: 'Eventbrite',
                //     value: 'eventbrite',
                //     visible: this.toggles.eventByGeolocation
                // },
                {
                  text: 'Performers, Venues, Ticketing Websites',
                  value: 'eventful',
                  selected: true,
                  visible: this.toggles.eventByGeolocation,
                },
              ];
              this.locationSource = 'eventful';
            } else if (this.type === 'place') {
              if (this.toggles.placeCalendar) {
                if (toggleCommand.dataSource.place === 'facebook') {
                  this.sourceItems = [
                    {
                      text: 'Facebook Places',
                      value: 'facebook',
                      selected: true,
                      //visible: this.toggles.placeCalendar && this.toggles.dataSource.place === 'facebook'
                    },
                  ];
                } else if (toggleCommand.dataSource.place === 'google') {
                  this.sourceItems = [
                    {
                      text: 'Google Places',
                      value: 'google',
                      selected: true,
                      //visible: this.toggles.placeCalendar && this.toggles.dataSource.place === 'google'
                    },
                  ];
                }
                this.locationSource = toggleCommand.dataSource.place;
              }
            }
          }
        }
      });

    // receive from LocationFeedListComponent to edit a geo-location (adding more categories or delete)
    this.updateGeoLocationStore.updateGeoLocationCommand.takeUntil(this.isDestroyed).subscribe((location: HubFeed) => {
      if (!location || !location.id) return;

      console.log('updateGeoLocation', location);
      this.eventLocation.lat = location.lat;
      this.eventLocation.lng = location.lng;
      this.getLocationStatus();
      this.showSuccessInfo = false;
      this.zoom = ConfigService.config.google.locationMapZoom;
      this.isShowMarker = true;
    });
  }

  public get isEventEnabled() {
    return this.toggles.manualEvents || this.toggles.eventByGeolocation;
  }

  public get searchGeofenceDisabled() {
    return (
      (this.type === 'event' && !this.toggles.eventByGeolocation) ||
      (this.type === 'place' && (!this.toggles.googlePlaceGeofence || !this.toggles.placeCalendar))
    );
  }

  public loadLocationFeeds() {
    if (!this.hubLocations || !this.hubLocations.length) {
      this.isLoadingFeeds = true;
      this.hubApiService.getLocationFeeds(this.hubName).subscribe((data) => {
        this.hubLocations = data;
        this.isLoadingFeeds = false;
      });
    }
  }

  public showCategoryPopup() {
    let actions = <PullGooglePlaceTypeModalActions>{
      confirm: (data: any) => {
        let noDuplicated: any[] = [];
        for (const d of data) {
          if (!noDuplicated.any((x) => x.value === d.value)) {
            noDuplicated.push(d);
          }
        }
        this.selectedGoogleCategories = noDuplicated.sort((a, b) => a.value.localeCompare(b.value)); // remove duplicated, as same cateogry may under different types
      },
    };

    this.modalService.show({
      component: PullGooglePlaceTypeModalComponent,
      providers: [{ provide: PullGooglePlaceTypeModalActions, useValue: actions }],
      panelClass: 'width-modal-90p',
    });
  }

  public filterPlacesByCity() {
    if (!this.eventLocation.isFilterByCity) {
      this.eventLocation.filterByCity = null;
    } else {
      this.eventLocation.filterByCity = this.locationPlaceCityState; //this.locationPlaceId;
    }
  }

  public changeTooltip() {
    if (this.pageSource === constantTooltip.facebookString) {
      this.pageTooltip = constantTooltip.facebookTooltip;
    } else if (this.pageSource === constantTooltip.eventbriteString) {
      this.pageTooltip = constantTooltip.eventbriteTooltip;
    } else if (this.pageSource === constantTooltip.eventfulString) {
      this.pageTooltip = constantTooltip.eventfulTooltip;
    }
  }

  public locationStatus() {
    this.showSuccessInfo = false;
    this.getLocationStatus();
  }

  public pageSourceChange(target) {
    this.pageSource = target.value;
    this.changeTooltip();
  }

  public findOnMapBySource(target) {
    this.locationSource = target.value;
    this.findOnMap();
  }

  public findOnMap() {
    if (this.autoCompletedAddress) {
      this.showSuccessInfo = false;
      this.eventLocation.lat = this.autoCompletedAddress.lat;
      this.eventLocation.lng = this.autoCompletedAddress.lng;
      // this.eventLocation.filterByCity = this.eventLocation.isFilterByCity ? this.locationSource === 'eventful' ? this.autoCompletedAddress.cityName : this.autoCompletedAddress.placeId : '';
      this.eventLocation.stateAbbr = this.autoCompletedAddress.stateAbbr;
      this.locationPlaceId =
        this.locationSource === 'eventful' ? this.autoCompletedAddress.cityName : this.autoCompletedAddress.placeId;
      if (this.autoCompletedAddress.country === 'United States') {
        this.locationPlaceCityState = `${this.autoCompletedAddress.cityName}, ${this.autoCompletedAddress.stateAbbr}`;
      } else {
        // some city are not the same when you filter place by city
        // e.g., Ibiza Spain, stateAbbr = IB, but if you use Ibiza,IB,Spain to get Google place id, it is different with you use Ibiza,Spain
        this.locationPlaceCityState = `${this.autoCompletedAddress.cityName}, ${this.autoCompletedAddress.country}`;
      }
      this.eventLocation.filterByCity = this.eventLocation.isFilterByCity ? this.locationPlaceCityState : null;
      this.zoom = ConfigService.config.google.locationMapZoom;
      this.isShowMarker = true;

      this.getLocationStatus();
    } else {
      this.resetMap();
    }
  }

  public isCategoryExisting(category: string): boolean {
    return this.eventLocation.categories.any((x) => x === category);
  }

  public addCategoriesToLocation(event?: ButtonTriggerEvent) {
    if (!this.selectedGoogleCategories.length) {
      event && event.immediateComplete();
      this.showCategoryPopup();
      return;
    }

    GeoService.reset();
    const points = GeoService.getPoints(
      this.eventLocation.lat,
      this.eventLocation.lng,
      (this.eventLocation.radius * this.mileToMeters) / 1000
    );

    this.inAddingLocationFeed = true;
    this.hubApiService
      .updateGoogleLocationFeed(this.hubName, {
        id: this.eventLocation.id,
        categories: this.selectedGoogleCategories,
        radius: this.eventLocation.radius,
        isRepullExistingCategories: this.isRepullExistingCategories,
        points,
        filterByCity: this.eventLocation.filterByCity,
      })
      .finally(() => {
        event.complete();
      })
      .subscribe((data) => {
        this.checkPullingStatus(data);
      });
  }

  public addLocation(event: ButtonTriggerEvent) {
    if (this.locationSource === 'eventful') {
      alert('This feature is deprecated');
      event.complete();
      return;
    }

    if (!this.isFeedExisted && this.checkIfExceedLimit()) {
      event.complete();
      return;
    }

    this.showSuccessInfo = false;

    if (this.isFeedExisted) {
      if (!this.isConfirmChecked) {
        // shake the confirm checkbox
        this.renderer.addClass(this.confirmCheckbox.nativeElement, 'ig-shake');
        event.immediateComplete();
        setTimeout(() => {
          this.renderer.removeClass(this.confirmCheckbox.nativeElement, 'ig-shake');
        }, 500);
        return;
      }
      this.inAddingLocationFeed = true;
      this.hubApiService
        .removeLocationFeed(this.hubName, this.eventLocation.feedId, this.locationSource)
        .finally(() => {
          event.complete();
          this.inAddingLocationFeed = false;
        })
        .subscribe(() => {
          this.locationFormGroup.markAsPristine();
          this.showSuccessInfo = true;

          setTimeout(() => {
            this.showSuccessInfo = false;
            this.infoWindow.close();
            this.addressInput.clear();

            this.getHubLocations();
          }, 1500);
        });
      return;
    }

    this.inAddingLocationFeed = true;
    if (this.locationSource == 'facebook') {
      // let points = GeoService.getPoints(this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius);
      // console.log(points);

      this.hubApiService
        .addFacebookLocationFeed(
          this.hubName,
          new AddFacebookLocationFeedCommand(
            this.eventLocation.address,
            this.eventLocation.displayTitle ? this.eventLocation.displayTitle : this.autoCompletedAddress.address,
            this.hubName,
            this.eventLocation.filterByCity,
            [], //points,
            this.eventLocation.lat,
            this.eventLocation.lng,
            this.eventLocation.radius,
            this.eventLocation.stateAbbr,
            this.eventLocation.tags
          )
        )
        .finally(() => {
          event.complete();
          this.inAddingLocationFeed = false;
          this.eventLocation.filterByCity = null;
          this.getHubLocations();
        })
        .subscribe(() => {
          this.locationFormGroup.markAsPristine();
          this.showSuccessInfo = true;
        });
    } else if (this.locationSource === 'google') {
      GeoService.reset();
      let points = GeoService.getPoints(
        this.eventLocation.lat,
        this.eventLocation.lng,
        (this.eventLocation.radius * this.mileToMeters) / 1000
      );
      console.log(`points.length: ${points.length}`);
      console.log(`this.eventLocation.filterByCity: ${this.eventLocation.filterByCity}`);

      this.hubApiService
        .addGoogleLocationFeed(
          this.hubName,
          new AddFacebookLocationFeedCommand(
            this.eventLocation.address,
            this.eventLocation.displayTitle ? this.eventLocation.displayTitle : this.autoCompletedAddress.address,
            this.hubName,
            this.eventLocation.filterByCity,
            points,
            this.eventLocation.lat,
            this.eventLocation.lng,
            this.eventLocation.radius,
            this.eventLocation.stateAbbr,
            this.eventLocation.tags,
            'google',
            this.selectedGoogleCategories.map((y) => y.value)
          )
        )
        .finally(() => {
          event.complete();
          this.eventLocation.filterByCity = null;
          this.getHubLocations();
        })
        .subscribe((data) => {
          if (data) {
            this.checkPullingStatus(data);
            // if (data.status === 'under pulling') {
            //   this.alertify.warning(data.msg);
            //   this.inAddingLocationFeed = false;
            // } else if (data.status === 'pulling') {
            //   let getPullingStatus = setInterval(() => {
            //     this.hubApiService.checkPullingGooglePlaceStatus(this.hubName).subscribe((data) => {
            //       if (data && !data.isPulling) {
            //         clearInterval(getPullingStatus);
            //         this.inAddingLocationFeed = false;
            //         this.locationFormGroup.markAsPristine();
            //         this.showSuccessInfo = true;
            //         this.percentage = '';
            //       } else {
            //         this.percentage = data.progress;
            //         if (this.percentage && this.percentage.toString().includes('99')) {
            //           this.percentage += `...Uploading images to AWS`;
            //         }
            //       }
            //     });
            //   }, 10000);
            // }
          }
          event.complete();
        });
    } else if (this.locationSource == 'eventbrite') {
      this.hubApiService
        .addEventBriteLocationFeed(
          this.hubName,
          new AddFacebookLocationFeedCommand(
            this.eventLocation.address,
            this.eventLocation.displayTitle ? this.eventLocation.displayTitle : this.autoCompletedAddress.address,
            this.hubName,
            null,
            null,
            this.eventLocation.lat,
            this.eventLocation.lng,
            this.eventLocation.radius,
            this.eventLocation.tags,
            config.eventbrite
          )
        )
        .finally(() => {
          event.complete();
          this.inAddingLocationFeed = false;
        })
        .subscribe(() => {
          this.locationFormGroup.markAsPristine();
          this.showSuccessInfo = true;
          this.getHubLocations();
        });
    } else if (this.locationSource == 'eventful') {
      this.hubApiService
        .addEventfulLocationFeed(
          this.hubName,
          new AddFacebookLocationFeedCommand(
            this.eventLocation.address,
            this.eventLocation.displayTitle ? this.eventLocation.displayTitle : this.autoCompletedAddress.address,
            this.hubName,
            this.eventLocation.filterByCity,
            null,
            this.eventLocation.lat,
            this.eventLocation.lng,
            this.eventLocation.radius,
            this.eventLocation.stateAbbr,
            this.eventLocation.tags,
            'eventful'
          )
        )
        .finally(() => {
          event.complete();
          this.inAddingLocationFeed = false;
        })
        .subscribe(() => {
          this.locationFormGroup.markAsPristine();
          this.showSuccessInfo = true;
          this.getHubLocations();
        });
    }
  }

  public toReadable(code: string) {
    return PlaceService.toReadableCategory(code);
  }

  private checkPullingStatus(status: { status: string; msg: string }) {
    if (status.status === 'under pulling') {
      this.alertify.warning(status.msg);
      this.inAddingLocationFeed = false;
    } else if (status.status === 'pulling') {
      let getPullingStatus = setInterval(() => {
        this.hubApiService.checkPullingGooglePlaceStatus(this.hubName).subscribe((data) => {
          if (data && !data.isPulling) {
            clearInterval(getPullingStatus);
            this.inAddingLocationFeed = false;
            this.locationFormGroup.markAsPristine();
            this.showSuccessInfo = true;
            this.percentage = '';
          } else {
            this.percentage = data.progress;
            if (this.percentage && this.percentage.toString().includes('99')) {
              this.percentage += `...Uploading images to AWS`;
            }
          }
        });
      }, 10000);
    }
  }

  private checkIfExceedLimit() {
    // only restrict event page limit now
    if (this.locationSource === 'google') return false;

    if (this.hubLocations && this.hubLocations.length) {
      let isExceedLimit = false;
      // adding place location feed
      // if (this.locationSource === 'facebook' || this.locationSource === 'google') {
      if (this.locationSource === 'facebook') {
        //     if (this.hubLocations.filter(x => x.socialName === 'facebook' || x.socialName === 'google').length >= config.maxLocationFeedLimit) {
        if (this.hubLocations.filter((x) => x.socialName === 'facebook').length >= config.maxLocationFeedLimit) {
          isExceedLimit = true;
        }
      } else {
        // adding event location feed
        if (
          this.hubLocations.filter((x) => x.socialName === 'eventbrite' || x.socialName === 'eventful').length >=
          config.maxLocationFeedLimit
        ) {
          isExceedLimit = true;
        }
      }
      if (isExceedLimit) {
        let data = <ConfirmModalData>{
          confirmModalIcon: 'warning',
          confirmModalTitle: 'Warning',
          confirmModalDescription: `The number of locations you have added has exceeded the limit, please contact our team, emailing <a href="mailto:aline@iti-digital.com">aline@iti-digital.com</a> or call us at 912-267-1558</p>`,
          confirmModalCancelButtonText: 'OK',
          isAsync: true,
        };

        let actions = <ConfirmModalActions>{};

        this.modalService.show({
          component: ConfirmModalComponent,
          providers: [
            { provide: ConfirmModalActions, useValue: actions },
            { provide: ConfirmModalData, useValue: data },
          ],
        });
        return true;
      }
    }
    return false;
  }

  private getHubPageFeeds() {
    let times = 0;
    let getFeeds = () =>
      this.hubApiService
        .getPageFeeds(this.hubName)
        .catch((err) => {
          if (times < 3) {
            getFeeds();
          }
          times++;
          return Observable.throw(err.statusText);
        })
        .subscribe((data) => {
          this.hubPages = data;
          let pageCommand = new HubFacebookFeedsCommand(data);
          this.hubFacebookFeedsStore.pagesCommand.next(pageCommand);
        });
    getFeeds();
  }

  private getHubLocations() {
    let times = 0;
    this.isLoadingFeeds = true;
    let getFeeds = () =>
      this.hubApiService
        .getLocationFeeds(this.hubName)
        .catch((err) => {
          if (times < 3) {
            getFeeds();
          }
          times++;
          return Observable.throw(err.statusText);
        })
        .subscribe((data) => {
          this.isLoadingFeeds = false;
          this.hubLocations = data;
          this.hubFacebookLocationFeedsStore.locationCommand.next(new HubFacebookFeedsCommand(this.hubLocations));
        });
    getFeeds();
  }

  private getLocationStatus() {
    this.hubApiService
      .getLocationStatus(
        this.hubName,
        this.autoCompletedAddress ? this.autoCompletedAddress.lat : this.eventLocation.lat,
        this.autoCompletedAddress ? this.autoCompletedAddress.lng : this.eventLocation.lng,
        this.locationSource
      )
      .subscribe((result) => {
        if (result) {
          this.isFeedExisted = result.connected;
          if (this.isFeedExisted) {
            this.eventLocation.displayTitle = result.title;
            this.eventLocation.id = result.feedId;
          } else {
            this.eventLocation.displayTitle = this.autoCompletedAddress.address;
          }
          if (result.radius) {
            this.eventLocation.radius = result.radius / config.mileToMeters;
          }
          this.eventLocation.feedId = result.feedId;
          this.eventLocation.filterByCity = result.filterByCity;
          this.eventLocation.categories = result.categories.sort((a, b) => a.localeCompare(b));
        }
      });
  }

  private resetMap() {
    this.eventLocation.lat = ConfigService.config.google.USCenter.lat;
    this.eventLocation.lng = ConfigService.config.google.USCenter.lng;
    this.eventLocation.filterByCity = null;
    this.isShowMarker = false;
    this.zoom = ConfigService.config.google.fullUSMapZoom;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.account/content.management/search.geofence/search.geofence.component.ts